"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const WizardStepIndicator_1 = __importDefault(require("@Components/WizardFlow/WizardStepIndicator"));
require("./index.scss");
const WizardStepIndicators = ({ steps, currentIndex }) => (react_1.default.createElement("div", { className: 'wizard-step-indicator-row' }, steps.map(({ stepIndicator }, index) => (react_1.default.createElement(WizardStepIndicator_1.default, { key: stepIndicator.label, index: index, currentIndex: currentIndex, stepIndicator: stepIndicator })))));
exports.default = WizardStepIndicators;
